import { render, staticRenderFns } from "./PDPWhatSInside.vue?vue&type=template&id=69956b38&scoped=true"
import script from "./PDPWhatSInside.vue?vue&type=script&lang=js"
export * from "./PDPWhatSInside.vue?vue&type=script&lang=js"
import style0 from "./PDPWhatSInside.vue?vue&type=style&index=0&id=69956b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69956b38",
  null
  
)

export default component.exports